export function FormSkeleton({
  fieldCount,
  label,
  sectionCount = 0,
  showCheckbox = false,
}: {
  fieldCount: number;
  label: string;
  sectionCount?: number;
  showCheckbox?: boolean;
}) {
  return (
    <div className="lockerverse-form-skeleton__loading">
      <span className="lockerverse-form-skeleton__sr-only" role="status">
        {label}
      </span>
      <div aria-hidden="true" className="lockerverse-form-skeleton">
        <div className="lockerverse-form-skeleton__branding">
          <span className="lockerverse-form-skeleton__avatar" />
          <span className="lockerverse-form-skeleton__community" />
        </div>
        <div className="lockerverse-form-skeleton__fields">
          {Array.from({ length: fieldCount }, (_, index) => (
            <div className="lockerverse-form-skeleton__field" key={index}>
              <span className="lockerverse-form-skeleton__label" />
              <span className="lockerverse-form-skeleton__input" />
            </div>
          ))}
        </div>
        {Array.from({ length: sectionCount }, (_, index) => (
          <div className="lockerverse-form-skeleton__section" key={index}>
            <span className="lockerverse-form-skeleton__section-label" />
            <div className="lockerverse-form-skeleton__section-content">
              <span className="lockerverse-form-skeleton__section-full" />
              <div className="lockerverse-form-skeleton__section-grid">
                <span className="lockerverse-form-skeleton__section-half" />
                <span className="lockerverse-form-skeleton__section-half" />
              </div>
            </div>
          </div>
        ))}
        <div className="lockerverse-form-skeleton__actions">
          {showCheckbox ? (
            <span className="lockerverse-form-skeleton__check-line" />
          ) : null}
          <span className="lockerverse-form-skeleton__button" />
        </div>
      </div>
    </div>
  );
}
